import angular from 'angular';
import uiRouter from 'angular-ui-router';
import teamCalendarMobileComponent from './teamCalendarMobile.component';
import {STATES} from 'common/domain/states';
import {ROUTES} from 'common/domain/routes';
import monthSelector from './monthSelector/monthSelector';
import teamCalendarList from './teamCalendarList/teamCalendarList';

let teamCalendarMobileModule = angular.module('teamCalendarMobile', [
  uiRouter,
  monthSelector,
  teamCalendarList
])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state(STATES.VACATIONS_ABSENCES.TEAM_CALENDAR_MOBILE, {
        url: ROUTES.VACATIONS_ABSENCES.TEAM_CALENDAR_MOBILE,
        component: 'teamCalendarMobile',
        data: {
          requiresAuth: true,
          requiresManager: true,
        },
        resolve: {
          /* @ngInject */
          isWageInProcess: StatusAppCheckers => StatusAppCheckers.isWageInProcess()
        }
      });
  })

  .component('teamCalendarMobile', teamCalendarMobileComponent)

  .name;

export default teamCalendarMobileModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarMobile.js